export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14048.945163e4.jpg";